import KPICard, { KPIGrid } from "../../components/common/KPICard";

/**
 * The 12 KPI cards named in BRD §5.6.1, in that order and with the colours it
 * specifies: earnings-side tiles green, COD deductions red, Cash Payable dark.
 *
 * DDC / DPC is shown as a ratio rather than two tiles, per the BRD.
 */
const CARDS = [
  { key: "totalRiderCount", label: "Total Rider Count" },
  { key: "ordersCount", label: "Orders Count" },
  { key: "totalEarnings", label: "Total Earnings", unit: "OMR", tone: "positive" },
  { key: "tips", label: "Tips", unit: "OMR", tone: "positive" },
  { key: "incentives", label: "Incentives", unit: "OMR", tone: "positive" },
  { key: "extraIncentives", label: "Extra Incentives", unit: "OMR", tone: "positive" },
  { key: "benefits", label: "Benefits", unit: "OMR", tone: "positive" },
  { key: "positiveAdjustment", label: "Positive Adjustment", unit: "OMR", tone: "positive" },
  { key: "currentCod", label: "Current COD", unit: "OMR", tone: "negative" },
  { key: "previousCod", label: "Previous COD", unit: "OMR", tone: "negative" },
  { key: "ddcDpc", label: "DDC / DPC", ratio: true },
  { key: "cashPayable", label: "Cash Payable", unit: "OMR", tone: "dark" },
];

function formatRatio(ddc, dpc) {
  const fmt = (v) =>
    Number(v || 0).toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3,
    });
  return `${fmt(ddc)} / ${fmt(dpc)}`;
}

export default function PayoutKPICards({ kpis = {} }) {
  return (
    <KPIGrid minWidth={150}>
      {CARDS.map((card) =>
        card.ratio ? (
          // A ratio is text, not a number, so it bypasses the numeric formatter.
          <KPICard
            key={card.key}
            label={card.label}
            value={formatRatio(kpis.ddc, kpis.dpc)}
          />
        ) : (
          <KPICard
            key={card.key}
            label={card.label}
            value={kpis[card.key]}
            unit={card.unit}
            tone={card.tone}
            allowNegative
          />
        )
      )}
    </KPIGrid>
  );
}
